import styled from 'styled-components';
import tokens from '@veneer/tokens';

export const ActiveSessionsError = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.layout.size4};
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${tokens.layout.size4} 0 0 ${tokens.layout.size4};
  align-items: center;
  justify-content: center;
`;

export const SessionsContent = styled.div`
  display: flex;
  flex-direction: column;
`;
